import { QueryClient } from '@tanstack/react-query';

/**
 * Shared QueryClient defaults.
 *
 * These mirror skyview-client (www/src/react/App.tsx) so the two front ends
 * behave the same way when a developer moves between them:
 *
 * - `retry: false` — the API surfaces real errors (ApiError carries the status);
 *   silently retrying a 403 or a 404 only delays the message the user needs.
 * - `networkMode: 'always'` — never park a query in `paused` because the browser
 *   reported itself offline; the docs site is often behind a corporate proxy
 *   that makes navigator.onLine unreliable.
 *
 * `staleTime` is deliberately left at 0 here and raised per query: the admin
 * views want fresh data on every mount, the public docs pages do not.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
        networkMode: 'always',
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: false,
        networkMode: 'always',
      },
    },
  });
}

export const queryClient = createQueryClient();
